import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, GiftIcon, ShieldCheckIcon, CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../../utils/metaPixel';
export function StackSummary() {
  const tableRef = useRef(null);
  const tableInView = useInView(tableRef, {
    once: true,
    margin: '-60px'
  });
  const guaranteeRef = useRef(null);
  const guaranteeInView = useInView(guaranteeRef, {
    once: true,
    margin: '-60px'
  });
  const urgencyRef = useRef(null);
  const urgencyInView = useInView(urgencyRef, {
    once: true,
    margin: '-60px'
  });
  return <section className="w-full" style={{
    backgroundColor: '#FFF8F0'
  }} data-id="element-327">
      <div className="max-w-3xl mx-auto px-6 py-14 md:py-20" data-id="element-328">
        {/* ===== VALUE STACK TABLE ===== */}
        <motion.div ref={tableRef} initial={{
        opacity: 0,
        y: 30
      }} animate={tableInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-329">
          <h2 className="font-serif-display font-bold text-2xl md:text-3xl text-center mb-8" style={{
          color: '#1A1A1A'
        }} data-id="element-330">
            Veamos lo que llevas hoy:
          </h2>

          {/* Table */}
          <div className="rounded-xl overflow-hidden mb-8" style={{
          border: '1px solid rgba(184, 134, 11, 0.25)'
        }} data-id="element-331">
            {/* Header row */}
            <div className="grid grid-cols-[1fr_auto] px-5 py-3" style={{
            backgroundColor: '#122240'
          }} data-id="element-332">
              <span className="font-body text-sm font-bold uppercase tracking-wider" style={{
              color: '#D4A017'
            }} data-id="element-333">
                Qué recibes
              </span>
              <span className="font-body text-sm font-bold uppercase tracking-wider text-right" style={{
              color: '#D4A017'
            }} data-id="element-334">
                Valor
              </span>
            </div>

            {/* Row 1 — Main product */}
            <div className="grid grid-cols-[1fr_auto] px-5 py-4 items-center gap-4" style={{
            backgroundColor: '#FAF3E8',
            borderBottom: '1px solid rgba(184, 134, 11, 0.12)'
          }} data-id="element-335">
              <div className="flex items-start gap-3" data-id="element-336">
                <BookOpenIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                color: '#B8860B'
              }} aria-hidden="true" data-id="element-337" />
                <span className="font-body text-base" style={{
                color: '#1A1A1A'
              }} data-id="element-338">
                  Método Express Alteraciones: 7 Arreglos que Pagan la Renta
                </span>
              </div>
              <span className="font-body text-base font-semibold text-right" style={{
              color: '#3D3D3D'
            }} data-id="element-339">
                $27
              </span>
            </div>

            {/* Row 2 — Bonus 1 */}
            <div className="grid grid-cols-[1fr_auto] px-5 py-4 items-center gap-4" style={{
            backgroundColor: '#FFF8F0',
            borderBottom: '1px solid rgba(184, 134, 11, 0.12)'
          }} data-id="element-340">
              <div className="flex items-start gap-3" data-id="element-341">
                <GiftIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                color: '#D4A017'
              }} aria-hidden="true" data-id="element-342" />
                <span className="font-body text-base" style={{
                color: '#1A1A1A'
              }} data-id="element-343">
                  Bono #1: Kit Anti-Errores de Alteraciones (Cero Pánico)
                </span>
              </div>
              <span className="font-body text-base font-semibold text-right" style={{
              color: '#3D3D3D'
            }} data-id="element-344">
                $47
              </span>
            </div>

            {/* Row 3 — Bonus 2 */}
            <div className="grid grid-cols-[1fr_auto] px-5 py-4 items-center gap-4" style={{
            backgroundColor: '#FAF3E8',
            borderBottom: '1px solid rgba(184, 134, 11, 0.12)'
          }} data-id="element-345">
              <div className="flex items-start gap-3" data-id="element-346">
                <GiftIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                color: '#D4A017'
              }} aria-hidden="true" data-id="element-347" />
                <span className="font-body text-base" style={{
                color: '#1A1A1A'
              }} data-id="element-348">
                  Bono #2: Scripts de Confianza: Cómo Hablar con Clientes (Sin
                  Pena)
                </span>
              </div>
              <span className="font-body text-base font-semibold text-right" style={{
              color: '#3D3D3D'
            }} data-id="element-349">
                $47
              </span>
            </div>

            {/* Row 4 — Bonus 3 */}
            <div className="grid grid-cols-[1fr_auto] px-5 py-4 items-center gap-4" style={{
            backgroundColor: '#FFF8F0',
            borderBottom: '1px solid rgba(184, 134, 11, 0.12)'
          }} data-id="element-350">
              <div className="flex items-start gap-3" data-id="element-351">
                <GiftIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                color: '#D4A017'
              }} aria-hidden="true" data-id="element-352" />
                <span className="font-body text-base" style={{
                color: '#1A1A1A'
              }} data-id="element-353">
                  Bono #3: Mini-Brand Express: Tu Sastrería en Casa en 30
                  Minutos
                </span>
              </div>
              <span className="font-body text-base font-semibold text-right" style={{
              color: '#3D3D3D'
            }} data-id="element-354">
                $47
              </span>
            </div>

            {/* Total real row */}
            <div className="grid grid-cols-[1fr_auto] px-5 py-4 items-center gap-4" style={{
            backgroundColor: 'rgba(212, 160, 23, 0.1)',
            borderBottom: '1px solid rgba(184, 134, 11, 0.2)'
          }} data-id="element-355">
              <span className="font-body text-base font-bold" style={{
              color: '#1A1A1A'
            }} data-id="element-356">
                TOTAL REAL
              </span>
              <span className="font-body text-xl font-bold line-through text-right" style={{
              color: 'rgba(61, 61, 61, 0.5)'
            }} data-id="element-357">
                $168
              </span>
            </div>

            {/* Your price row */}
            <div className="grid grid-cols-[1fr_auto] px-5 py-5 items-center gap-4" style={{
            backgroundColor: '#122240'
          }} data-id="element-358">
              <span className="font-body text-lg font-bold" style={{
              color: '#FAF3E8'
            }} data-id="element-359">
                Tu inversión hoy
              </span>
              <span className="font-serif-display font-bold text-3xl md:text-4xl text-right" style={{
              color: '#D4A017'
            }} data-id="element-360">
                $17.27
              </span>
            </div>
          </div>
        </motion.div>

        {/* ===== SUMMARY COPY ===== */}
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={tableInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-361">
          <p className="font-serif-display font-bold text-2xl md:text-3xl mb-4" style={{
          color: '#1A1A1A'
        }} data-id="element-362">
            Todo eso por{' '}
            <span style={{
            color: '#D4A017'
          }} data-id="element-363">
              $17.27
            </span>
            .
          </p>
          <p className="font-body text-lg leading-relaxed mb-2" style={{
          color: '#3D3D3D'
        }} data-id="element-364">
            Menos de lo que cobras por un ruedo de pantalón.
          </p>
          <p className="font-body text-lg leading-relaxed mb-6" style={{
          color: '#3D3D3D'
        }} data-id="element-365">
            Y si ese ruedo lo haces hoy, ya pagaste esto.
          </p>
          <p className="font-body text-base leading-relaxed" style={{
          color: '#3D3D3D'
        }} data-id="element-366">
            Esto no es un curso largo. No es teoría. No es "aprende en 6 meses".
          </p>
          <p className="font-body text-lg font-semibold mt-2" style={{
          color: '#1A1A1A'
        }} data-id="element-367">
            Es un manual táctico + 3 herramientas que puedes usar esta semana.
          </p>
        </motion.div>

        {/* ===== GUARANTEE BLOCK ===== */}
        <motion.div ref={guaranteeRef} className="rounded-xl p-8 md:p-10 text-center mb-12" style={{
        backgroundColor: '#0B1A2E'
      }} initial={{
        opacity: 0,
        y: 30
      }} animate={guaranteeInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-368">
          <ShieldCheckIcon className="w-14 h-14 mx-auto mb-4" style={{
          color: '#D4A017'
        }} aria-hidden="true" data-id="element-369" />
          <h3 className="font-serif-display font-bold text-xl md:text-2xl mb-4" style={{
          color: '#FAF3E8'
        }} data-id="element-370">
            GARANTÍA DE 30 DÍAS
          </h3>
          <p className="font-body text-base leading-relaxed max-w-xl mx-auto" style={{
          color: 'rgba(250, 243, 232, 0.8)'
        }} data-id="element-371">
            Si en 30 días sientes que no valió la pena, te devuelvo cada
            centavo. Sin preguntas. Sin trámites. Sin drama. Porque si no te
            ayuda a empezar o mejorar lo que ya haces, no merezco tu dinero.
          </p>
        </motion.div>

        {/* ===== MAIN CTA ===== */}
        <motion.div className="text-center mb-8" initial={{
        opacity: 0,
        y: 20
      }} animate={guaranteeInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-372">
          <motion.a href="https://manosquegeneran.com/cart/48283475017955:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="cta-glow inline-flex items-center justify-center gap-3 px-10 py-5 rounded-xl font-bold text-lg md:text-xl font-body transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95" style={{
          backgroundColor: '#D4A017',
          color: '#1A1A1A'
        }} whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.96
        }} aria-label="Descárgalo ahora por solo $17.27" data-id="element-373">
            DESCÁRGALO AHORA POR SOLO $17.27
            <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-374" />
          </motion.a>

          {/* Social proof */}
          <div className="mt-4 flex items-center justify-center gap-2" data-id="element-375">
            <div className="flex flex-col" data-id="element-376">
              <div className="flex items-center gap-1" data-id="element-377">
                <div className="flex items-center gap-0.5" data-id="element-378">
                  {[...Array(5)].map((_, i) => <span key={i} className="text-sm" style={{
                  color: '#D4A017'
                }} data-id="element-379">
                      ★
                    </span>)}
                </div>
                <span className="font-body text-xs" style={{
                color: 'rgba(61,61,61,0.6)'
              }} data-id="element-380">
                  +1,200 mujeres ya lo están logrando
                </span>
              </div>
            </div>
          </div>

          <p className="font-body text-sm mt-3" style={{
          color: '#3D3D3D'
        }} data-id="element-381">
            (Acceso inmediato. Los 3 bonos incluidos desde el primer segundo.)
          </p>
        </motion.div>

        {/* ===== MICRO-COPY ===== */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-12" data-id="element-382">
          <span className="flex items-center gap-1.5 font-body text-sm" style={{
          color: '#3D3D3D'
        }} data-id="element-383">
            <CheckCircle2Icon className="w-4 h-4" style={{
            color: '#D4A017'
          }} aria-hidden="true" data-id="element-384" />
            Descarga inmediata
          </span>
          <span className="flex items-center gap-1.5 font-body text-sm" style={{
          color: '#3D3D3D'
        }} data-id="element-385">
            <CheckCircle2Icon className="w-4 h-4" style={{
            color: '#D4A017'
          }} aria-hidden="true" data-id="element-386" />
            3 bonos incluidos sin costo adicional
          </span>
          <span className="flex items-center gap-1.5 font-body text-sm" style={{
          color: '#3D3D3D'
        }} data-id="element-387">
            <CheckCircle2Icon className="w-4 h-4" style={{
            color: '#D4A017'
          }} aria-hidden="true" data-id="element-388" />
            Garantía de 30 días
          </span>
          <span className="flex items-center gap-1.5 font-body text-sm" style={{
          color: '#3D3D3D'
        }} data-id="element-389">
            <CheckCircle2Icon className="w-4 h-4" style={{
            color: '#D4A017'
          }} aria-hidden="true" data-id="element-390" />
            Sin suscripciones, sin renovaciones
          </span>
          <span className="flex items-center gap-1.5 font-body text-sm" style={{
          color: '#3D3D3D'
        }} data-id="element-391">
            <CheckCircle2Icon className="w-4 h-4" style={{
            color: '#D4A017'
          }} aria-hidden="true" data-id="element-392" />
            Hecho para latinas en USA
          </span>
        </div>

        {/* ===== STITCH DIVIDER ===== */}
        <hr className="stitch-divider mb-12" data-id="element-393" />

        {/* ===== URGENCY CLOSE ===== */}
        <motion.div ref={urgencyRef} className="max-w-2xl mx-auto" initial={{
        opacity: 0,
        y: 30
      }} animate={urgencyInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-394">
          <p className="font-serif-display font-bold text-xl md:text-2xl mb-6" style={{
          color: '#1A1A1A'
        }} data-id="element-395">
            Una última cosa.
          </p>

          <p className="font-body text-lg leading-relaxed mb-4" style={{
          color: '#3D3D3D'
        }} data-id="element-396">
            Sé que estás pensando:
          </p>

          <p className="font-serif-display italic text-xl mb-6" style={{
          color: '#1A1A1A'
        }} data-id="element-397">
            "Lo veo después."
          </p>

          <p className="font-body text-lg leading-relaxed mb-4" style={{
          color: '#3D3D3D'
        }} data-id="element-398">
            Pero "después" tiene un problema.
          </p>

          <p className="font-body text-lg leading-relaxed mb-2" style={{
          color: '#3D3D3D'
        }} data-id="element-399">
            Las cuentas no esperan a que te sientas "lista".
          </p>
          <p className="font-body text-lg leading-relaxed mb-2" style={{
          color: '#3D3D3D'
        }} data-id="element-400">
            Las clientas que podrían estar llamándote hoy no van a esperarte.
          </p>
          <p className="font-body text-lg leading-relaxed mb-6" style={{
          color: '#3D3D3D'
        }} data-id="element-401">
            Y cada día que pasa con la máquina apagada es un día que alguien más
            está cobrando lo que tú podrías cobrar.
          </p>

          <p className="font-serif-display font-bold text-xl mb-2" style={{
          color: '#1A1A1A'
        }} data-id="element-402">
            No necesitas estar lista.
          </p>
          <p className="font-serif-display font-bold text-xl mb-8" style={{
          color: '#B8860B'
        }} data-id="element-403">
            Necesitas empezar.
          </p>

          <p className="font-body text-lg leading-relaxed mb-8" style={{
          color: '#3D3D3D'
        }} data-id="element-404">
            Y esto es exactamente lo que te hace empezar.
          </p>

          {/* Final CTA */}
          <div className="text-center" data-id="element-405">
            <motion.a href="https://manosquegeneran.com/cart/48283475017955:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="cta-glow inline-flex items-center justify-center gap-3 px-10 py-5 rounded-xl font-bold text-lg md:text-xl font-body transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95" style={{
            backgroundColor: '#D4A017',
            color: '#1A1A1A'
          }} whileHover={{
            scale: 1.04
          }} whileTap={{
            scale: 0.96
          }} aria-label="Descárgalo ahora" data-id="element-406">
              DESCÁRGALO AHORA
              <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-407" />
            </motion.a>

            <p className="font-serif-display italic text-base mt-4" style={{
            color: 'rgba(61, 61, 61, 0.6)'
          }} data-id="element-408">
              (Tu máquina lleva tiempo esperando. Hoy le das una razón.)
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}